module.exports = __webpack_public_path__ + "static/media/royal-gaming.9c11a654.webp";